import React from 'react'
import { getButtonClasses } from '@/lib/utils'
import type { buttonVariants, buttonSizes } from '@/lib/utils'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof buttonVariants
  size?: keyof typeof buttonSizes
  loading?: boolean
  children: React.ReactNode
}

const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  className,
  children,
  ...props 
}) => {
  return (
    <button
      className={getButtonClasses(variant, size, className)}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <div className="flex items-center">
          <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin mr-2" />
          {children}
        </div>
      ) : (
        children
      )}
    </button>
  )
}

export default Button
